// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/**
 * npm install file-saver
 * npm install jquery --save
 * npm install weixin-js-sdk --save
 * npm install vue-wechat-title --save
 * npm install jsencrypt --save
 * npm install jsbarcode --save
 * npm install jr-qrcode --save
 * npm install vuex@3.1.0 --save  //可选
 */
import Vue from 'vue'
import App from './App'
import router from './router'   //$router 整个应用只有一个实例，用于导航等	$route 每个组件都有当前路由信息，可获取参数等
import axios from './utils/myaxios'
import store from './store/index'

// import "./assets/css/ui.css" 
import "./assets/css/jquery.flipster.css"
import "./assets/css/main.css"  //uniapp

import $ from "jquery";
import "./utils/jsbridge_init.js";
import utils from './utils/utils'  //全局方法
import config from "./utils/config";
//import "./utils/mui.js";  //如报错：babelrc中ignore



// import loading from './utils/loading.js'; // 引入loading
// Vue.use(loading); // 全局使用loading

//小程序标题(配合mate,v-wechat-title="$route.meta.title")
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

import { JSEncrypt } from 'jsencrypt';
//JSEncrypt加密方法
Vue.prototype.$encryptData = function(publicKey, data) {
  let encrypt = new JSEncrypt();//new一个对象
  encrypt.setPublicKey(publicKey);//设置公钥
  let result = encrypt.encrypt(data);//data,此处不用注意+号,因为rsa自己本身已经base64转码了,不存在+,全部是二进制数据
  return result
}
//JSEncrypt解密方法
Vue.prototype.$decryptData = function(privateKey, data) {
  let decrypt = new JSEncrypt();// 新建JSEncrypt对象
  decrypt.setPrivateKey(privateKey);// 设置私钥
  let result = decrypt.decrypt(data);// 解密数据
  return result
}


//引入swiper
// 方案A：使用 Swiper 5.x（最兼容）
// 可先卸载 npm uninstall swiper vue-awesome-swiper
// npm install swiper@5.4.5 vue-awesome-swiper@4.1.1
import VueAwesomeSwiper from 'vue-awesome-swiper'
// Swiper 8 样式导入
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/scrollbar'
// import 'swiper/css/autoplay'
// import 'swiper/css/effect-fade'
// Swiper 5 样式导入( Swiper 5 使用 swiper/css/swiper.css，而6,7,8等 swiper/swiper-bundle.css。)
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper);


//显示日志(本段注释即可关闭vconsole)
import Vconsole from 'vconsole'
const vConsole = new Vconsole()  //所有环境显示


//挂载到原型（也可挂载到window对象（最简单））, Vue 3 不再推荐使用 Vue.prototype，而是使用 app.config.globalProperties。
// Vue.prototype.$config=config;
window.$config = config;
Vue.prototype.$axios = axios; // 全局启用网络请求插件
window.$utils = utils; //全局注册
window.$store = store;
window.$ = $;


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,   
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js